import type React from 'react'
import { Modal, Text } from 'ui'
import { useShiftDetail } from '../useShiftDetail'
import { addHours } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { getShiftTimezone } from 'lib/shift'

interface Props {
  trigger: React.ReactNode
}

const DEFAULT_SHIFT_END_PAYMENT_DELAY_HOURS = 24

export const TimesheetReviewPeriodModal = ({ trigger }: Props) => {
  const { shift } = useShiftDetail()

  if (!shift) return null

  const paidByDate = addHours(
    new Date(shift.endsAt),
    shift.shiftEndPaymentDelayHours || DEFAULT_SHIFT_END_PAYMENT_DELAY_HOURS
  )
  const formattedPaidByDate = formatInTimeZone(
    paidByDate,
    getShiftTimezone(shift),
    'eee MMM do, h:mma zzz'
  )

  return (
    <Modal
      title={`Work will be auto-approved ${shift.shiftEndWorkApprovalDelayHours}hrs after shift end time`}
      trigger={trigger}
      width={[1, 900]}
    >
      <Text mb={2}>
        Please review promptly. Workers will be paid by {formattedPaidByDate}.
      </Text>
    </Modal>
  )
}
